export class IndicatorTIQColumnsHelper {
    public static getTIQColumns(): Array<any> {
        return [
            {
                id: 3282055,
                referenceName: "KELTNER_BOTTOM [periods]",
                displayName: "Keltner Bottom",
                abbreviatedName: "Keltner Channel Bottom ([periods])",
                prefersOwnPane: false,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 255, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Periods to use for Keltner channel",
                        minimum: 1,
                        maximum: 200,
                        columnId: 3282055,
                        defaultValue: 10,
                        value: 10
                    }
                ]
            },
            {
                id: 3282056,
                referenceName: "BB_TOP [periods] [std_dev]",
                displayName: "Bollinger Bands",
                abbreviatedName: "BB Upper",
                prefersOwnPane: false,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(255, 127, 80, 1)",
                upColor: "rgba(255, 127, 80, 1)",
                downColor: "rgba(255, 127, 80, 1)",
                topColor: "rgba(255, 127, 80, 1)",
                bottomColor: "rgba(255, 127, 80, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "description",
                        minimum: 1,
                        maximum: 200,
                        columnId: 3282056,
                        defaultValue: 20,
                        value: 20
                    },
                    {
                        name: "Standard Deviation",
                        referenceId: "std_dev",
                        format: "2",
                        description: "Number of standard deviations",
                        minimum: 1,
                        maximum: 20,
                        columnId: 3282056,
                        defaultValue: 2,
                        value: 2
                    }
                ]
            },
            {
                id: 3282053,
                referenceName: "VWAP",
                displayName: "VWAP",
                abbreviatedName: "VWAP",
                prefersOwnPane: false,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: []
            },
            {
                id: 3282057,
                referenceName: "BB_BOTTOM [periods] [std_dev]",
                displayName: "BB Lower",
                abbreviatedName: "BB Lower",
                prefersOwnPane: false,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(255, 127, 80, 1)",
                upColor: "rgba(255, 127, 80, 1)",
                downColor: "rgba(255, 127, 80, 1)",
                topColor: "rgba(255, 127, 80, 1)",
                bottomColor: "rgba(255, 127, 80, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Number of periods to use for the Bollinger Band",
                        minimum: 1,
                        maximum: 200,
                        columnId: 3282057,
                        defaultValue: 20,
                        value: 20
                    },
                    {
                        name: "Standard Dev",
                        referenceId: "std_dev",
                        format: "2",
                        description: "Number of standard deviations",
                        minimum: 1,
                        maximum: 10,
                        columnId: 3282057,
                        defaultValue: 2,
                        value: 2
                    }
                ]
            },
            {
                id: 3282047,
                referenceName: "RSI [periods] CLOSE",
                displayName: "RSI",
                abbreviatedName: "RSI ([periods])",
                prefersOwnPane: true,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(255, 0, 0, 1)",
                upColor: "rgba(0, 0, 255, 1)",
                downColor: "rgba(255, 0, 0, 1)",
                topColor: "rgba(0, 255, 0, 1)",
                bottomColor: "rgba(255, 255, 255, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Periods for the RSI",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282047,
                        defaultValue: 14,
                        value: 14
                    }
                ]
            },
            {
                id: 3282080,
                referenceName: "MONEY_FLOW_INDEX [periods]",
                displayName: "Money Flow Index",
                abbreviatedName: "MONEY_FLOW_INDEX [periods]",
                prefersOwnPane: true,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(80, 96, 63, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Look back periods for the mony flow index",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282080,
                        defaultValue: 14,
                        value: 14
                    }
                ]
            },
            {
                id: 3282066,
                referenceName: "ADX",
                displayName: "Average Direction Index",
                abbreviatedName: "ADX",
                prefersOwnPane: true,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Lookback for ADX",
                        minimum: 1,
                        maximum: 200,
                        columnId: 3282066,
                        defaultValue: 14,
                        value: 14
                    }
                ]
            },
            {
                id: 3282067,
                referenceName: "Dollar Volume",
                displayName: "Dollar Volume",
                abbreviatedName: "Dollar Volume",
                prefersOwnPane: true,
                code: "((ref(0,\"CLOSE\") + ref(0,\"LOW\") + ref(0,\"HIGH\")) / 3 ) * ref(0,\"VOLUME\")",
                category: "",
                colorType: "One",
                indicatorType: "Bar",
                color: "rgba(43, 233, 142, 1)",
                upColor: "rgba(41, 243, 23, 1)",
                downColor: "rgba(243, 36, 23, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: []
            },
            {
                id: 3282062,
                referenceName: "Williams %R [periods]",
                displayName: "Williams %R",
                abbreviatedName: "Williams %R [periods]",
                prefersOwnPane: true,
                code: "(max_val(14, 0, \"HIGH\", 1)-ref(0,\"CLOSE\")) / (max_val(14, 0, \"HIGH\", 1)- min_val(14, 0, \"LOW\", 1)) * -100",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(204, 0, 204, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "2",
                        description: "Look back period for Williams %R",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282062,
                        defaultValue: 14,
                        value: 14
                    }
                ]
            },
            {
                id: 3282058,
                referenceName: "ATR [periods]",
                displayName: "Average True Range",
                abbreviatedName: "ATR [periods]",
                prefersOwnPane: true,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(223, 58, 1, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Number of periods to use for average true range",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282058,
                        defaultValue: 14,
                        value: 14
                    }
                ]
            },
            {
                id: 3282049,
                referenceName: "SMA [periods] CLOSE",
                displayName: "Moving Average - SMA",
                abbreviatedName: "SMA ([periods])",
                prefersOwnPane: false,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 255, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Periods for the SMA",
                        minimum: 1,
                        maximum: 500,
                        columnId: 3282049,
                        defaultValue: 20,
                        value: 20
                    }
                ]
            },
            {
                id: 3282048,
                referenceName: "EMA [periods] CLOSE",
                displayName: "Moving Average - EMA",
                abbreviatedName: "EMA ([periods])",
                prefersOwnPane: false,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 255, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Periods for the EMA",
                        minimum: 1,
                        maximum: 300,
                        columnId: 3282048,
                        defaultValue: 30,
                        value: 30
                    }
                ]
            },
            {
                id: 3282052,
                referenceName: "MP HIGH",
                displayName: "Multi-Period High",
                abbreviatedName: "MP High ([periods])",
                prefersOwnPane: false,
                code: "max_val([periods], 1, \"HIGH\")",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 255, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Periods for the multi-period high",
                        minimum: 1,
                        maximum: 500,
                        columnId: 3282052,
                        defaultValue: 20,
                        value: 20
                    }
                ]
            },
            {
                id: 3282050,
                referenceName: "DC TOP",
                displayName: "Donchian Channel",
                abbreviatedName: "Donchian Channel ([periods])",
                prefersOwnPane: false,
                code: "max_val([periods], 1, \"HIGH\")",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(80, 178, 218, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Periods for the Dochian Channel",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282050,
                        defaultValue: 20,
                        value: 20
                    }
                ]
            },
            {
                id: 3282061,
                referenceName: "ROC [periods]",
                displayName: "Rate of Change",
                abbreviatedName: "ROC [periods]",
                prefersOwnPane: true,
                code: "(ref(0,\"CLOSE\") - ref([periods],\"CLOSE\")) / ref([periods],\"CLOSE\") * 100",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Number of periods in rate of change look back",
                        minimum: 1,
                        maximum: 252,
                        columnId: 3282061,
                        defaultValue: 9,
                        value: 9
                    }
                ]
            },
            {
                id: 3282073,
                referenceName: "MP LOW",
                displayName: "Multi-Period Low",
                abbreviatedName: "MP Low ([periods])",
                prefersOwnPane: false,
                code: "min_val([periods], 1, \"LOW\")",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 255, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "periods of multi-period low",
                        minimum: 1,
                        maximum: 50,
                        columnId: 3282073,
                        defaultValue: 20,
                        value: 20
                    }
                ]
            },
            {
                id: 3282060,
                referenceName: "BB_WIDTH [periods] [std_dev]",
                displayName: "Bollinger Band Width",
                abbreviatedName: "Bollinger Band Width",
                prefersOwnPane: true,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(255, 153, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Look back period",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282060,
                        defaultValue: 20,
                        value: 20
                    },
                    {
                        name: "Standard Deviation",
                        referenceId: "std_dev",
                        format: "0",
                        description: "Standard Deviation",
                        minimum: 1,
                        maximum: 10,
                        columnId: 3282060,
                        defaultValue: 2,
                        value: 2
                    }
                ]
            },
            {
                id: 3282051,
                referenceName: "DC BOTTOM",
                displayName: "Donchian Bottom",
                abbreviatedName: "DC Bottom ([periods])",
                prefersOwnPane: false,
                code: "min_val([periods], 1, \"LOW\")",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(80, 178, 218, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: []
            },
            {
                id: 3282070,
                referenceName: "MACD_LINE [fast_periods] [slow_periods]",
                displayName: "MACD",
                abbreviatedName: "MACD_LINE [fast_periods] [slow_periods]",
                prefersOwnPane: true,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(255, 153, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Fast EMA",
                        referenceId: "fast_periods",
                        format: "0",
                        description: "Fast EMA for MACD",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282070,
                        defaultValue: 12,
                        value: 12
                    },
                    {
                        name: "Slow EMA",
                        referenceId: "slow_periods",
                        format: "0",
                        description: "Slow EMA for MACD",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282070,
                        defaultValue: 26,
                        value: 26
                    },
                    {
                        name: "Smoothing Line",
                        referenceId: "smoothing",
                        format: "0",
                        description: "Smoothing period for the signal line of the MACD",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282070,
                        defaultValue: 9,
                        value: 9
                    }
                ]
            },
            {
                id: 3282071,
                referenceName: "MACD_SIGNAL_LINE [fast_periods]",
                displayName: "Signal Line",
                abbreviatedName: "MACD_SIGNAL_LINE [fast_periods]",
                prefersOwnPane: false,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 255, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: []
            },
            {
                id: 3282072,
                referenceName: "MACD_HIST [fast_periods] [slow_periods] [smoothing]",
                displayName: "MACD_HIST",
                abbreviatedName: "MACD_HIST [fast_periods] [slow_periods] [smoothing]",
                prefersOwnPane: false,
                code: "",
                category: "",
                colorType: "UpDown",
                indicatorType: "Bar",
                color: "rgba(0, 0, 0, 1)",
                upColor: "rgba(41, 243, 23, 1)",
                downColor: "rgba(243, 36, 23, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: []
            },
            {
                id: 3282054,
                referenceName: "KELTNER_TOP [periods]",
                displayName: "Keltner Channel",
                abbreviatedName: "Keltner Channel ([periods])",
                prefersOwnPane: false,
                code: "",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 255, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Periods to use for Keltner channel",
                        minimum: 1,
                        maximum: 200,
                        columnId: 3282054,
                        defaultValue: 10,
                        value: 10
                    }
                ]
            },
            {
                id: 3282081,
                referenceName: "Drawdown",
                displayName: "Drawdown",
                abbreviatedName: "Drawdown",
                prefersOwnPane: true,
                code: "( max_val([periods],0,\"HIGH\") - ref(0,\"CLOSE\") ) / max_val([periods],0,\"HIGH\") *-100",
                category: "",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(184, 0, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Lookback for drawdown chart",
                        minimum: 1,
                        maximum: 1000,
                        columnId: 3282081,
                        defaultValue: 252,
                        value: 252
                    }
                ]
            },
            {
                id: 3282076,
                referenceName: "Distance from EMA",
                displayName: "Distance from EMA",
                abbreviatedName: "Dis EMA",
                prefersOwnPane: true,
                code: "(ref(0,\"CLOSE\") - ref(0,\"EMA 8 CLOSE\")) / ref(0,\"CLOSE\") *100",
                category: "DEVELOPMENT",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: []
            },
            {
                id: 3282079,
                referenceName: "PAT_REC_INDEX [periods]",
                displayName: "TI Pattern Rec",
                abbreviatedName: "PAT_REC_INDEX [periods]",
                prefersOwnPane: true,
                code: "",
                category: "DEVELOPMENT",
                colorType: "UpDown",
                indicatorType: "Bar",
                color: "rgba(0, 0, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Look back for pattern rec indicator ",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282079,
                        defaultValue: 24,
                        value: 24
                    }
                ]
            },
            {
                id: 3282063,
                referenceName: "TI_SCORE",
                displayName: "TI Strength",
                abbreviatedName: "TI Strength",
                prefersOwnPane: true,
                code: "",
                category: "DEVELOPMENT",
                colorType: "One",
                indicatorType: "Bar",
                color: "rgba(0, 255, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: []
            },
            {
                id: 3282069,
                referenceName: "STOCH_K [periods]",
                displayName: "Stochastics",
                abbreviatedName: "STOCH_K ([periods])",
                prefersOwnPane: true,
                code: "",
                category: "DEVELOPMENT",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(31, 46, 222, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Look back period for %K",
                        minimum: 1,
                        maximum: 100,
                        columnId: 3282069,
                        defaultValue: 14,
                        value: 14
                    }
                ]
            },
            {
                id: 3282075,
                referenceName: "Pivot Point (P)",
                displayName: "Pivot Point (P)",
                abbreviatedName: "PP",
                prefersOwnPane: false,
                code: "((ref(0,\"YESTERDAY_OHLC CLOSE\") + ref(0,\"YESTERDAY_OHLC LOW\") + ref(0,\"YESTERDAY_OHLC HIGH\")) / 3 )",
                category: "DEVELOPMENT",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: []
            },
            {
                id: 3282077,
                referenceName: "REL_VOL",
                displayName: "Relative Volume",
                abbreviatedName: "REL_VOL",
                prefersOwnPane: true,
                code: "",
                category: "DEVELOPMENT",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 0, 0, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: []
            },
            {
                id: 3282046,
                referenceName: "AVG_VOLUME",
                displayName: "Average Volume",
                abbreviatedName: "AVG_VOLUME",
                prefersOwnPane: true,
                code: "average([periods], 1, \"VOLUME\", 1)",
                category: "OHLC",
                colorType: "One",
                indicatorType: "Line",
                color: "rgba(0, 255, 255, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: [
                    {
                        name: "Periods",
                        referenceId: "periods",
                        format: "0",
                        description: "Periods to use for moving average.",
                        minimum: 1,
                        maximum: 1000,
                        columnId: 3282046,
                        defaultValue: 30,
                        value: 30
                    }
                ]
            },
            {
                id: 3282045,
                referenceName: "VOLUME",
                displayName: "Volume",
                abbreviatedName: "VOLUME",
                prefersOwnPane: true,
                code: "current(\"volume\")",
                category: "OHLC",
                colorType: "One",
                indicatorType: "Bar",
                color: "rgba(0, 0, 255, 1)",
                upColor: "rgba(0, 0, 0, 1)",
                downColor: "rgba(0, 0, 0, 1)",
                topColor: "rgba(0, 0, 0, 1)",
                bottomColor: "rgba(0, 0, 0, 1)",
                parameters: []
            }
        ];
    }
}